import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "actionLog";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
